export const POST_HEADER_MENU_CLASS_NAME = 'post-header-menu'
export const REACTION_BUTTON_CLASS_NAME = 'reaction-button'
export const POST_CARD_CLASS_NAME = 'post-card'
